// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Z1iY","delete":"styles_delete__U92oi","update":"styles_update__3Isqw","add":"styles_add__EbOzN"};